(function(){
  document.documentElement.classList.add('df-motion-ready');

  function initRotators(){
    document.querySelectorAll('[data-announcement-rotator]').forEach(function(root){
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-announcement-slide]'));
      if(!slides.length) return;
      var index = slides.findIndex(function(s){ return s.classList.contains('is-active'); });
      if(index < 0) index = 0;
      function show(next){
        index = (next + slides.length) % slides.length;
        slides.forEach(function(slide, i){
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
      }
      var prev = root.querySelector('[data-announcement-prev]');
      var next = root.querySelector('[data-announcement-next]');
      if(prev) prev.addEventListener('click', function(){ show(index - 1); });
      if(next) next.addEventListener('click', function(){ show(index + 1); });
      var interval = parseInt(root.getAttribute('data-interval') || '4200', 10);
      if(slides.length > 1 && interval > 0){
        var timer = window.setInterval(function(){ show(index + 1); }, interval);
        root.addEventListener('mouseenter', function(){ window.clearInterval(timer); });
        root.addEventListener('mouseleave', function(){
          window.clearInterval(timer);
          timer = window.setInterval(function(){ show(index + 1); }, interval);
        });
      }
      show(index);
    });
  }

  function initMobileMenus(){
    document.querySelectorAll('[data-menu-toggle]').forEach(function(button){
      var targetId = button.getAttribute('aria-controls');
      var nav = document.getElementById(targetId);
      if(!nav) return;
      button.addEventListener('click', function(){
        var open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', open ? 'false' : 'true');
        nav.classList.toggle('is-open', !open);
      });
    });
  }

  function initReveal(){
    var elements = document.querySelectorAll('[data-reveal]');
    if(!('IntersectionObserver' in window)){
      elements.forEach(function(el){el.classList.add('is-visible');});
      return;
    }
    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {threshold: 0.08});
    elements.forEach(function(el){observer.observe(el);});
  }

  document.addEventListener('DOMContentLoaded', function(){
    initRotators();
    initMobileMenus();
    initReveal();
  });
})();
